import axios from "axios";
import React, {useCallback, useEffect, useState} from "react";
import {useTable} from "react-table";
import {
    getAccountManagerNotesInfoByLoggedUserApi,
    removeAccountManagerNotesByIDApi,
    saveAccountManagerNotesApi
} from "../Api";
import ConsoleHelper from "../ConsoleHelper";
import {useHistory, useLocation} from "react-router-dom";
import DataTable from "react-data-table-component";

export default function AccountManagerNotes(props) {
  const [isTableVisible, setIsTableVisible] = useState(true);
    const loggedUserStorage = sessionStorage.getItem('loggedUserStorage');
  const [data, setData] = useState([]);
  const [isPrivate, setIsPrivate] = useState(0);
  const [note, setNote] = useState();
    const [rtaNumber, setRtaNumber] = useState();
    const [paramNewNoteID, setParamNewNoteID] = useState(0);
    const [paramAccountID, setParamAccountID] = useState();
    const [paramSourceType, setParamSourceType] = useState(4);
    const [pending, setPending] = useState(true);
    const history = useHistory();
    const location = useLocation();

    const tableStyles = {
        rows: {
            style: {
                minHeight: '40px', // override the row height
                fontSize: 'smaller'

            },
        },
        headCells: {
            style: {
                paddingLeft: '2px', // override the cell padding for data cells
                paddingRight: '2px',
                fontWeight: 'bold',
                textDecoration: 'underline'
            },
        },
        cells: {
            style: {
                paddingLeft: '2px', // override the cell padding for data cells
                paddingRight: '2px',
                whiteSpace: 'inherit'
            },
        },
        div: {
            firstChild : {
                color: 'black'
            }
        }
    };

    const updateNotes = useCallback(() => {
  const getNotesData = async () => {
      ConsoleHelper("Called on Page Load......");
      //setRta and account number
      let rtaFromLoc = (history.location.state?.from?.split("?")[1].split("=")?.[1]?.split("&")?.[0]).replace(/[^\w @]/g, '');
      let paramAccountIDLoc = history.location.state?.from?.split("?")[1].split("=")?.[2]?.replace(/[^\w @]/g, '');
      console.log(rtaFromLoc," ---- ",paramAccountIDLoc)
      //setRta and account number
      setRtaNumber(rtaFromLoc);
      setParamAccountID(paramAccountIDLoc);
      history.push({
          pathname: "/accountManager/notes",
          search: `rta=${rtaFromLoc}&AccountID=${paramAccountIDLoc}`,
      });
      //const result = await axios.get(`${getAccountManagerNotesInfoByLoggedUserApi}?paramSourceCode=${paramAccountID}`,{
          const result = await axios.get(`${getAccountManagerNotesInfoByLoggedUserApi}?paramSourceCode=11411`,{
          mode: 'no-cors' // 'cors' by default
      });

        setData(result.data?.response);
      setPending(false);
  };
        getNotesData();
    }, []);

    const datacolumns = [
        {
            name: 'Note Text',
            selector: row => row.noteText,
            sortable: true,
            left: true,
            when: row => row.noteText < 300,
            style: row => ({ maxWidth: row.isSpecial ? 'pink' : '750px' ,whiteSpace: 'normal',overflow: 'hidden',textOverflow: 'ellipsis'}),
        },
        {
            name: 'Date ',
            selector: row => row.dateTimeNote,
            sortable: true,
            left: true,
            width: '140px',
            //grow: 2,

        },
        {
            name: 'Note Type',
            font: '10px',
            width: '60px',
            selector: row => (row.noteType === 1 ? "Private" : "Public"),
        },
        {
            name: 'Edit',
            font: '10px',
            left: true,
            width: '50px',
            selector: row => (
                <span
                    class="input-group-text"
                    role="button"
                    style={{
                        cursor: "pointer",
                        textDecoration: "none",
                        fontWeight: "normal",
                        height: "20px"

                    }}
                    onClick={() => handleEditClick(row)}
                >
                    Edit
                </span>


            )
        },
        {
            name: 'Delete',
            font: '10px',
            left: true,
            width: '60px',
            selector: row => (
                <span
                    class="input-group-text"
                    role="button"
                    style={{
                        cursor: "pointer",
                        textDecoration: "none",
                        fontWeight: "normal",
                        height: "20px"

                    }}
                    onClick={() => handleDelete(row)}
                >
                    Delete
                </span>


            )
        }
    ];

  const handleEditClick = (data) => {
    setNote(data.note);
    setIsTableVisible(false);
    data.noteType == "Private" ? setIsPrivate(1) : setIsPrivate(0);
  };


  const handleDelete = (data) => {
      data["paramCurrentUserID"] = loggedUserStorage;
      data["paramNoteID"] = data.noteID;
    //console.log(data, "data is here");

    // call for delete api
      axios.post(
          `${removeAccountManagerNotesByIDApi}`,data
      ).then(res => {
          alert("Notes Deleted Successfully!!");
          updateNotes();
      }).catch(error => {
          console.log("Exception Thrown::save Override values",error);
      });

  };


  const handleSave = () => {
    const data = {};
      data["paramUserID"] = loggedUserStorage;
      data["paramSourceType"] = paramSourceType;
      data["paramSourceCode"] = paramAccountID;
      data["paramSourceCode"] = paramAccountID;
      data["paramNoteType"] = (isPrivate === true ? 1 : 0);
      data["paramNoteText"] = note;
      data["paramNewNoteID"] = paramNewNoteID;
    ConsoleHelper(isPrivate)
    // call the api after getting the result
      axios.post(
          `${saveAccountManagerNotesApi}`,data
      ).then(res => {
              alert("Notes Saved Successfully!!")
          updateNotes();
          }).catch(error => {
          console.log("Exception Thrown::save Override values",error);
      });
    //
    setIsTableVisible(true);
  };
  const handleCancel = () => {
    setIsTableVisible(true);
  };

  useEffect(() => {
      updateNotes();
  }, []);
  return (
    <div>
      {isTableVisible ? (
          <div className={`col col-md-12`}>
        <>
          {" "}
            <span
                className="d-block p-2 text-white mb-6"
                style={{background: "#002170"}}
            >
                Account Notes List
              </span>
            <DataTable
                columns={datacolumns}
                data={data}
                noHeader
                dense
                highlightOnHover
                progressPending={pending}
                pointerOnHover
                customStyles={tableStyles}
            />
          <div className="mt-3 d-flex justify-content-center">
            <span
              class="input-group-text"
              role="button"
              onClick={() => {
                setIsTableVisible(false);
              }}
            >
              Add
            </span>
          </div>
        </>
          </div>
      ) : (
        <form className="mt-3">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              checked={isPrivate}
              onChange={() => setIsPrivate(!isPrivate)}
            />
            <label className="form-check-label" for="Private">
              Private
            </label>
          </div>
          <div class="form-group">
            <label htmlFor="exampleFormControlTextarea1">Note:</label>
            <textarea
              class="form-control"
              rows="3"
              defaultValue={note}
              style={{ maxHeight: 200 }}
              onChange={(e) => setNote(e.target.value)}
            />
          </div>
          <div className="mt-3 d-flex">
            <span class="input-group-text" role="button" onClick={handleSave}>
              Save
            </span>
            <span
              class="input-group-text ml-3"
              role="button"
              onClick={() => {
                handleCancel();
              }}
            >
              Cancel
            </span>
          </div>
        </form>
      )}
    </div>
  );
}
